import 'jquery';

export default {
  ready() {
    // Phone button
    jQuery(".btn-call-us").on("click", function(){
      if(jQuery('#div-phones').css('display') != 'flex'){
        jQuery('#div-phones').fadeIn('slow');
        jQuery('#div-phones').css('display','flex');
      }else{
        jQuery('#div-phones').fadeOut('slow');
      }
    });

    // Hours button
    jQuery(".btn-hours").on("click", function(){
      if(jQuery('#div-hours').css('display') != 'flex'){
        jQuery('#div-hours').fadeIn('slow');
        jQuery('#div-hours').css('display','flex');
      }else{
        jQuery('#div-hours').fadeOut('slow');
      }
    });
  }
}